'use strict';
import angular from 'angular';
import './scripts/exceptionlogs.ctrls';
import './scripts/exceptionlogs.services';

import exceptionLogsHtmlUrl from './views/exceptionLogs.html';

angular.module('exceptionlogs', [
    'exceptionlogs.ctrls',
    'exceptionlogs.services'
])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('exceptionLogs',   {
                parent: 'layout',
                url: '/admin/exceptionLogs',
                templateUrl: exceptionLogsHtmlUrl,
                controller: 'ExceptionLogsController',
            })
    }]);